import { render, staticRenderFns } from "./newPressesionStepOne.vue?vue&type=template&id=acc3e7ca&scoped=true"
import script from "./newPressesionStepOne.vue?vue&type=script&lang=js"
export * from "./newPressesionStepOne.vue?vue&type=script&lang=js"
import style0 from "./newPressesionStepOne.vue?vue&type=style&index=0&id=acc3e7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc3e7ca",
  null
  
)

export default component.exports